var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.5H9.25V15C9.25 13.4812 10.4812 12.25 12 12.25C13.5188 12.25 14.75 13.4812 14.75 15V19.5H18.5V9.75L12 4.875L5.5 9.75V19.5ZM5.5 21C5.08333 21 4.72917 20.8542 4.4375 20.5625C4.14583 20.2708 4 19.9167 4 19.5V9.75C4 9.51667 4.05417 9.29167 4.1625 9.075C4.27083 8.85833 4.41667 8.68333 4.6 8.55L11.1 3.675C11.2333 3.575 11.375 3.5 11.525 3.45C11.675 3.4 11.8333 3.375 12 3.375C12.1667 3.375 12.325 3.4 12.475 3.45C12.625 3.5 12.7667 3.575 12.9 3.675L19.4 8.55C19.5833 8.68333 19.7292 8.85833 19.8375 9.075C19.9458 9.29167 20 9.51667 20 9.75V19.5C20 19.9167 19.8542 20.2708 19.5625 20.5625C19.2708 20.8542 18.9167 21 18.5 21H13.25V15C13.25 14.3096 12.6904 13.75 12 13.75C11.3096 13.75 10.75 14.3096 10.75 15V21H5.5Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/home_inactive.7ace9e947504f87b3c9d965749cfe044.svg";
export { ForwardRef as ReactComponent };